/**
 * Created by dannyr on 13/12/2016.
 */

import React from "react";
import { PopupHoverContainer } from "@similarweb/ui-components";
import type { WaPositionTooltipContentProps } from "../WaPositionTooltip/WaPositionTooltipContent";
import { WaPositionTooltipContent } from "../WaPositionTooltip/WaPositionTooltipContent";

interface WaPositionTooltipProps extends WaPositionTooltipContentProps {
    children: React.ReactNode;
}

export class WaPositionTooltip extends React.Component<WaPositionTooltipProps> {
    static defaultProps = { data: [] };

    render() {
        return (
            <PopupHoverContainer
                content={() => <WaPositionTooltipContent data={this.props.data} />}
                config={{ enabled: true, placement: "left", width: 184 }}
            >
                {this.props.children}
            </PopupHoverContainer>
        );
    }
}
